<template>
  <v-alert class="py-3 px-8" color="blue darken-2" text>
    <h2 class="mb-2">Signed up with just your phone number?</h2>
    <v-btn
      :to="{ name: LoginPhoneCheckRoute }"
      color="blue darken-2"
      small
      depressed
      exact
      outlined
      class="mb-2"
      >Find Account by Phone</v-btn
    >
  </v-alert>
</template>

<script>
import { CustomerRoutes } from '@/constants/RouteNames'

export default {
  name: 'CustomerFindAccountByPhoneNotice',
  components: {},
  data() {
    return {
      LoginPhoneCheckRoute: CustomerRoutes.LOGIN_WITH_PHONE,
    }
  },
}
</script>
